sw-loading {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  $timing: 1.4s;
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    > div {
      margin-top: 10px;
      max-width: 200px;
      text-align: center;
      font-weight: 700;
    }
  }
  svg {
    width: 56px;
    height: 56px;
    path {
      transform-origin: center center;
      animation: heartbeat $timing infinite;
    }
    circle {
      opacity: 0;
      transform-origin: 256px 277px;
      animation: ripple $timing * 3 infinite linear;
      &.one {
        animation-delay: $timing * 0.12;
      }
      &.two {
        animation-delay: $timing * 0.36; // second pulse starts at 36%
      }
      &.three {
        animation-delay: $timing * 1.12;
      }
      &.four {
        animation-delay: $timing * 1.36;
      }
      &.five {
        animation-delay: $timing * 2.12;
      }
      &.six {
        animation-delay: $timing * 2.36;
      }
    }
  }

  @keyframes heartbeat {
    0% {
      transform: scale(1);
    }

    12% {
      transform: scale(1.15);
    }

    24% {
      transform: scale(1);
    }

    36% {
      transform: scale(1.15);
    }

    48% {
      transform: scale(1);
    }

    100% {
      transform: scale(1);
    }
  }
  @keyframes ripple {
    0% {
      transform: scale(0.07);
      opacity: 0.1;
    }
    50% {
      transform: scale(1);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
}
